import {
  listBroadcasts,
  getBroadcast,
  createBroadcast,
  updateBroadcast,
  deleteBroadcast,
  listBroadcastCategories,
  createBroadcastCategoryAPI,
  updateBroadcastCategoryAPI,
  deleteBroadcastCategoryAPI,
} from "app/services/broadcasts.service";
import {
  BROADCAST_REQUEST,
  BROADCAST_FAILURE,
  FETCH_BROADCASTS_SUCCESS,
  GET_BROADCAST_SUCCESS,
  CREATE_BROADCAST_SUCCESS,
  UPDATE_BROADCAST_SUCCESS,
  DELETE_BROADCAST_SUCCESS,
  FETCH_BROADCAST_CATEGORIES_SUCCESS,
  ADD_BROADCAST_CATEGORY,
  UPDATE_BROADCAST_CATEGORY,
  REMOVE_BROADCAST_CATEGORY,
} from "./types";

// ─── Action Creators ──────────────────────────────────────────────────────

export const broadcastRequest = () => ({ type: BROADCAST_REQUEST });

export const broadcastFailure = (error) => ({
  type: BROADCAST_FAILURE,
  payload: error,
});

export const fetchBroadcastsSuccess = (data) => ({
  type: FETCH_BROADCASTS_SUCCESS,
  payload: data,
});

export const getBroadcastSuccess = (data) => ({
  type: GET_BROADCAST_SUCCESS,
  payload: data,
});

export const createBroadcastSuccess = (broadcast) => ({
  type: CREATE_BROADCAST_SUCCESS,
  payload: broadcast,
});

export const updateBroadcastSuccess = (broadcast) => ({
  type: UPDATE_BROADCAST_SUCCESS,
  payload: broadcast,
});

export const deleteBroadcastSuccess = (id) => ({
  type: DELETE_BROADCAST_SUCCESS,
  payload: id,
});

export const fetchBroadcastCategoriesSuccess = (data) => ({
  type: FETCH_BROADCAST_CATEGORIES_SUCCESS,
  payload: data,
});

export const addBroadcastCategorySuccess = (category) => ({
  type: ADD_BROADCAST_CATEGORY,
  payload: category,
});

export const updateBroadcastCategorySuccess = (category) => ({
  type: UPDATE_BROADCAST_CATEGORY,
  payload: category,
});

export const removeBroadcastCategorySuccess = (categoryId) => ({
  type: REMOVE_BROADCAST_CATEGORY,
  payload: categoryId,
});

// ─── Thunk Actions ────────────────────────────────────────────────────────

export const fetchBroadcasts = (params) => {
  return async (dispatch) => {
    dispatch(broadcastRequest());
    try {
      const res = await listBroadcasts(params);
      dispatch(fetchBroadcastsSuccess(res));
      return res;
    } catch (error) {
      dispatch(
        broadcastFailure(
          error?.response?.data?.message ||
            error?.message ||
            "Lỗi khi tải thông báo",
        ),
      );
      return null;
    }
  };
};

export const fetchBroadcast = (id) => {
  return async (dispatch) => {
    dispatch(broadcastRequest());
    try {
      const res = await getBroadcast(id);
      dispatch(getBroadcastSuccess(res));
      return res;
    } catch (error) {
      dispatch(
        broadcastFailure(
          error?.response?.data?.message ||
            error?.message ||
            "Lỗi khi tải thông báo",
        ),
      );
      return null;
    }
  };
};

export const addBroadcast = (broadcastData) => {
  return async (dispatch) => {
    dispatch(broadcastRequest());
    try {
      const res = await createBroadcast({ data: broadcastData });
      dispatch(createBroadcastSuccess(res?.data || res));
      return res;
    } catch (error) {
      dispatch(
        broadcastFailure(
          error?.response?.data?.message ||
            error?.message ||
            "Lỗi khi gửi thông báo",
        ),
      );
      return null;
    }
  };
};

export const editBroadcast = ({ id, data }) => {
  return async (dispatch) => {
    dispatch(broadcastRequest());
    try {
      const res = await updateBroadcast({ id, data });
      dispatch(updateBroadcastSuccess(res?.data || res));
      return res;
    } catch (error) {
      dispatch(
        broadcastFailure(
          error?.response?.data?.message ||
            error?.message ||
            "Lỗi khi cập nhật thông báo",
        ),
      );
      return null;
    }
  };
};

export const removeBroadcast = (id) => {
  return async (dispatch) => {
    dispatch(broadcastRequest());
    try {
      const res = await deleteBroadcast(id);
      dispatch(deleteBroadcastSuccess(id));
      return res;
    } catch (error) {
      dispatch(
        broadcastFailure(
          error?.response?.data?.message ||
            error?.message ||
            "Lỗi khi xóa thông báo",
        ),
      );
      return null;
    }
  };
};

export const fetchBroadcastCategories = (params) => {
  return async (dispatch) => {
    dispatch(broadcastRequest());
    try {
      const res = await listBroadcastCategories(params);
      dispatch(fetchBroadcastCategoriesSuccess(res));
      return res;
    } catch (error) {
      dispatch(
        broadcastFailure(
          error?.response?.data?.message ||
            error?.message ||
            "Lỗi khi tải danh mục",
        ),
      );
      return null;
    }
  };
};

export const addBroadcastCategory = (name) => {
  return async (dispatch) => {
    dispatch(broadcastRequest());
    try {
      const res = await createBroadcastCategoryAPI({ data: { name } });
      dispatch(addBroadcastCategorySuccess(res?.data || res));
      return res;
    } catch (error) {
      dispatch(
        broadcastFailure(
          error?.response?.data?.message ||
            error?.message ||
            "Lỗi khi thêm danh mục",
        ),
      );
      return null;
    }
  };
};

export const editBroadcastCategory = ({ id, data }) => {
  return async (dispatch) => {
    dispatch(broadcastRequest());
    try {
      const res = await updateBroadcastCategoryAPI({ id, data });
      dispatch(updateBroadcastCategorySuccess(res?.data || res));
      return res;
    } catch (error) {
      dispatch(
        broadcastFailure(
          error?.response?.data?.message ||
            error?.message ||
            "Lỗi khi cập nhật danh mục",
        ),
      );
      return null;
    }
  };
};

export const removeBroadcastCategory = (id) => {
  return async (dispatch) => {
    dispatch(broadcastRequest());
    try {
      const res = await deleteBroadcastCategoryAPI(id);
      dispatch(removeBroadcastCategorySuccess(id));
      return res;
    } catch (error) {
      dispatch(
        broadcastFailure(
          error?.response?.data?.message ||
            error?.message ||
            "Lỗi khi xóa danh mục",
        ),
      );
      return false;
    }
  };
};
